import { Routes, Route } from "react-router-dom";

import "./App.css";
import Contactus from "./component/User Page/Contact us/Contactus";
import Home2 from "./component/User Page/home/Home2";
// import jwt_decode from "jwt-decode";
import About from "./component/User Page/About/About";
import Program from "./component/User Page/program/Program";
import JoinUs from "./component/User Page/Joinus/JoinUs";
import Gallery from "./component/User Page/Gallery/Gallery";
import News from "./component/User Page/News/News";
import MassTrain from "./component/User Page/program/MassTrain";
import Vocation from "./component/User Page/program/Vocation";
import Seeding from "./component/User Page/program/Seeding";
import Network from "./component/User Page/program/Network";
import AddPerson from "./component/User Page/Joinus/AddPerson";
import PageCheck from "./component/User Page/Joinus/Check Out/PageCheck";

function App() {
  (function (w, d) {
    w.CollectId = "650d51fd8a3fde15c3ecf123";
    var h = d.head || d.getElementsByTagName("head")[0];
    var s = d.createElement("script");
    s.setAttribute("type", "text/javascript");
    s.async = true;
    s.setAttribute("src", "https://collectcdn.com/launcher.js");
    h.appendChild(s);
  })(window, document);

  return (
    <div className="App w-full   bg-gray-50">
      <Routes>
        <Route exact path="/about" element={<About />} />
      </Routes>
      <Routes>
        <Route exact path="/join" element={<JoinUs />} />
      </Routes>
      <Routes>
        <Route exact path="/gallery" element={<Gallery />} />
      </Routes>
      <Routes>
        <Route exact path="/news" element={<News />} />
      </Routes>

      <Routes>
        <Route exact path="/program" element={<Program />} />
      </Routes>
      <Routes>
        <Route exact path="/masstrain" element={<MassTrain />} />
      </Routes>
      <Routes>
        <Route exact path="/vocationatrain" element={<Vocation />} />
      </Routes>
      <Routes>
        <Route exact path="/seeding" element={<Seeding />} />
      </Routes>
      <Routes>
        <Route exact path="/businessnetwork" element={<Network />} />
      </Routes>
      {/* contact us */}
      <Routes>
        <Route exact path="/contactus" element={<Contactus />} />
      </Routes>
      <Routes>
        <Route exact path="/addperson" element={<AddPerson />} />
      </Routes>
      <Routes>
        <Route exact path="/sponsor" element={<PageCheck />} />
      </Routes>
      {/* about city */}

      <Routes>
        <Route exact path="/" element={<Home2 />} />
      </Routes>
    </div>
  );
}

export default App;
